const heading = {
  display: `block`,
  color: `gray900`,
  textDecoration: `none`,
  fontWeight: 600,
};

export default {
  large: {
    ...heading,
    fontSize: [9, null, null, 10],
    lineHeight: '54px',
    fontWeight: 700,
  },
  h1: {
    ...heading,
    fontSize: [6, null, null, 8],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '24px',
  },
  h1doppelganger: {
    ...heading,
    fontSize: [6, null, null, 8],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '18px',
    mt: '-6px'
  },
  h1bold: {
    ...heading,
    fontSize: [6, null, null, 9],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '24px',
    fontWeight: 800,
    lineHeight: '72px',
  },
  h1semiBold: {
    ...heading,
    fontSize: [6, null, null, 9],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '24px',
    fontWeight: 600,
    lineHeight: '72px',
  },
  h1medium: {
    ...heading,
    fontSize: '36px',
    lineHeight: '54px',
    mb: '24px',
  },
  h2: {
    ...heading,
    fontSize: [5, null, null, 7],
    lineHeight: ['36px', null, null, '54px'],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '24px',
  },
  h2compact: {
    ...heading,
    fontSize: ['30px', null, null, '36px'],
    lineHeight: '44px',
    mb: '20px',
  },
  h2h3:
  {
    ...heading,
    lineHeight: '38px',
    fontSize: '30px',
  },
  h2h3adaptive:
  {
    ...heading,
    lineHeight: '38px',
    fontSize: ['20px', null, null, '30px']
  },
  h2h3adaptiveMb:
  {
    ...heading,
    lineHeight: '38px',
    fontSize: ['20px', null, null, '30px'],
    mb: '20px',
  },
  h3: {
    ...heading,
    fontSize: [4, null, null, 5],
  },
  h3italic: {
    ...heading,
    fontStyle: 'italic',
    fontWeight: 400,
    fontSize: [4, null, null, 5],
    lineHeight: ['30px', null, null, '36px'],
  },
  h4: {
    ...heading,
    fontSize: [2, null, null, 4],
  },
  h5: {
    ...heading,
    fontWeight: 600,
    fontSize: [2, null, null, 4],
  },
  h6: {
    ...heading,
    fontSize: 2,
  },
  subtitle: {
    fontSize: [3, null, null, 4],
  },
  subtitleBold: {
    fontSize: [3, null, null, 4],
    color: `gray900`,
    fontWeight: 600,
  },
  subtitleItalic: {
    ...heading,
    fontSize: [3, null, null, 4],
    fontStyle: 'italic',
    fontWeight: 400,
  },
  subtitleItalicCompact: {
    ...heading,
    fontSize: [3, null, null, 4],
    fontStyle: 'italic',
    fontWeight: 400,
    lineHeight: '30px'
  },
  medium: {
    fontSize: [2, null, null, 3],
  },
  p: {
    fontSize: 2,
    lineHeight: '24px',
  },
  pLight: {
    fontSize: ['16px', null, null, '20px'],
    fontWeight: 300,
    lineHeight: '30px',
    color: '#F2F4F7'
  },
  pMediumLight: {
    fontSize: ['16px', null, null, '17px'],
    fontWeight: 400,
    lineHeight: '28px',
  },
  pmd: {
    fontSize: 2,
    lineHeight: '24px',
    fontWeight: 500,
  },
  pbold: {
    fontSize: 2,
    lineHeight: '24px',
    fontWeight: 600,
  },
  header: {
    fontSize: 2,
    fontWeight: 600,
    lineHeight: '24px',
  },
  headerMedium: {
    fontSize: 2,
    fontWeight: 500,
    lineHeight: '24px',
  },
  subHeaderBold: {
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '28px'
  },
  subHeaderSuperBold: {
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '28px'
  },
  button: {
    fontSize: [1, null, null, 2],
    fontWeight: 500,
  },
  header1: {
    fontSize: 1,
    fontWeight: 600,
  },
  smallMedium: {
    fontSize: 2,
    lineHeight: '20px',
  },
  small: {
    fontSize: 1,
    m: 0,
  },
  xsmall: {
    fontSize: 0,
    fontWeight: 700,
    m: 0,
    letterSpacing: '1px',
  },
  ph1: {
    ...heading,
    fontSize: [6, null, null, 8],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '24px',
  },
  ph2: {
    ...heading,
    fontSize: [5, null, null, 7],
    lineHeight: ['36px', null, null, '54px'],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '24px',
  },
  h1h2: {
    ...heading,
    fontSize: [5, null, null, 7],
    lineHeight: ['36px', null, null, '54px'],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '24px',
  },
  h3h2: {
    ...heading,
    fontSize: [5, null, null, 7],
    lineHeight: ['36px', null, null, '54px'],
    maxWidth: '1240px',
    mx: `auto`,
    mb: '24px',
  },
};
